<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-size-66 md-medium-size-100 md-small-size-100 mx-auto"
      >
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>construction</md-icon>
            </div>
            <h4 class="title">{{ title }}</h4>
          </md-card-header>
          <md-card-content class="text-center">
            <h3>{{ $t('common.comingSoon') }}</h3>
            <p>{{ $t('common.comingSoonDesc') }}</p>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
// Placeholder for every Vivo companies screen (C2–C15) during Phase 2.
// Phase 5 replaces these with the real pages. The heading comes from the
// route's meta.titleKey so each placeholder is labelled correctly.
export default {
  name: 'ComingSoon',
  computed: {
    title() {
      const key = this.$route.meta && this.$route.meta.titleKey;
      return key ? this.$t(key) : this.$t('common.comingSoon');
    },
  },
};
</script>
